<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formBussinessDocumentsResolution">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="bussinessDocumentsResolutionContract.userNameCreate"
              [createDate]="bussinessDocumentsResolutionContract.createDate"
              [userNameUpdate]="bussinessDocumentsResolutionContract.userNameUpdate"
              [updateDate]="bussinessDocumentsResolutionContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-bussinessDocumentsClass">
              <app-custom-input-text [value]="nameBussinessDocumentsTypeClass" [labelText]="'Clase'"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-branch">
              <app-custom-input-text [value]="codeNameBranch" [labelText]="'Sucursal'"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-enterprise">
              <app-custom-input-text [value]="codeNameEnterprise" [labelText]="'Empresa'"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-bussinessDocumentsType">
              <app-custom-inputgroup [inputValue]="codeNameBussinessDocumentsType" [labelText]="'Tipo Doc. Comercial'"
                [iconButton]="'pi pi-external-link'" [titleButton]="'Tipo Doc. Comercial'" [required]="true"
                [recovery]="true" (onClick)="openBusinessDocumentTypeSelectionModal()"></app-custom-inputgroup>
              <app-custom-modal #bussinessDocumentsTypes [header]="'Selección Tipos de Documentos Comerciales'"
                [width]="'70vw'" [children]="componentCitySelection" [inputs$]="inputsForSelectDocumentTypesModal$"
                [output$]="output$" (selectedItems)="changeBussinessDocumentsType($event)" hidden></app-custom-modal>
            </div>
            <div class="col field-consecutive">
              <app-custom-input-number formControlName="consecutive" [labelText]="'Consecutivo'" [required]="true"
                [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
            </div>
            <div class="col field-number">
              <app-custom-input-number formControlName="number" [labelText]="'Nro. Resolución'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col field-authorizeType">
              <app-custom-select formControlName="authorizeType" [labelText]="'Tipo Resolución'"
                [list]="listTypeResolution" [required]="true"></app-custom-select>
            </div>
            <div class="col field-dateResolution">
              <app-custom-datepicker formControlName="dateResolution" [labelText]="'Fecha'" [required]="true">
              </app-custom-datepicker>
            </div>
            <div class="col field-validity">
              <app-custom-input-number formControlName="validity"
                [labelText]="'Vigencia(Meses)'"></app-custom-input-number>
            </div>
            <div class="col field-technologicPassword">
              <app-custom-input-text formControlName="technologicPassword" [labelText]="'Clave Técnica'"
                [maxLength]="80"></app-custom-input-text>
            </div>
            <div class="col field-prefix">
              <app-custom-input-text formControlName="prefix" [labelText]="'Prefijo'"
                [maxLength]="4"></app-custom-input-text>
            </div>
            <div class="col field-initialDocument">
              <app-custom-input-text formControlName="initialDocument" [labelText]="'Factura Inicial'" [required]="true"
                [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="col field-finalDocument">
              <app-custom-input-text formControlName="finalDocument" [labelText]="'Factura Final'" [required]="true"
                [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="col field-idNumber">
              <app-custom-input-number formControlName="idNumber"
                [labelText]="'Id.Numeración'"></app-custom-input-number>
            </div>
            <div class="col field-button-send">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>